import React, { useState } from "react"

import JoinModal from "components/AudioRoom/JoinModal"
import useAudioInputDevices from "components/AudioRoom/useAudioInputDevices"
import useJoinAudioRoom from "components/AudioRoom/useJoinAudioRoom"

import AdminRoom from "./AdminRoom"

type AdminAudioRoomProps = {
  audioRoomId: string
  currentUserId: string
}

const AdminAudioRoom: React.FC<AdminAudioRoomProps> = ({
  audioRoomId,
  currentUserId,
}) => {
  const [fatalError, setFatalError] = useState<string>()
  const {
    chimeJoinInfo,
    controlsUnlockedUserIds,
    onJoin,
    isJoining,
    joinError,
  } = useJoinAudioRoom(audioRoomId)
  const {
    audioInputDevices,
    selectedAudioInputDeviceId,
    setSelectedAudioInputDeviceId,
    selectedAudioInputDeviceName,
    microphoneError,
  } = useAudioInputDevices()
  const displayedError = fatalError || joinError

  return (
    <div className="min-h-screen overflow-hidden bg-[#111] text-white">
      {displayedError ? (
        <p className="p-6 text-center italic text-white/60">{displayedError}</p>
      ) : !chimeJoinInfo ? (
        <JoinModal
          audioRoomId={audioRoomId}
          audioInputDevices={audioInputDevices}
          selectedAudioInputDeviceId={selectedAudioInputDeviceId}
          setSelectedAudioInputDeviceId={setSelectedAudioInputDeviceId}
          microphoneError={microphoneError}
          onJoin={onJoin}
          joining={isJoining}
        />
      ) : (
        <AdminRoom
          joinInfo={chimeJoinInfo}
          onFatalError={setFatalError}
          audioRoomId={audioRoomId}
          currentUserId={currentUserId}
          audioInputDeviceId={selectedAudioInputDeviceId}
          audioInputDeviceName={selectedAudioInputDeviceName}
          controlsUnlockedUserIds={controlsUnlockedUserIds}
        />
      )}
    </div>
  )
}

export default AdminAudioRoom
